var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayResponsibly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.25c.394 0 .715.32.715.714v4.857a.357.357 0 00.714 0V6.68a.715.715 0 011.428 0v4.142a.358.358 0 00.714 0V8.107a.714.714 0 011.429 0l.001 5.857c0 4.357-4.786 4.143-4.786 4.143-2.429 0-4.214-2.286-4.214-2.286L5.715 13.68a.998.998 0 01-.215-.643.978.978 0 011-1 .993.993 0 01.715.357l1.429 1.57v-6.57a.675.675 0 01.713-.714.675.675 0 01.714.714v3.428a.358.358 0 00.715 0V5.964c0-.394.32-.714.714-.714z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.685 2.005a1 1 0 01.608.288l4.414 4.414a1 1 0 01.293.707v9.172l-.005.099a1 1 0 01-.288.608l-4.414 4.414-.073.066a1 1 0 01-.535.222l-.1.005h-9.17a1 1 0 01-.708-.293l-4.414-4.414a1 1 0 01-.288-.608l-.005-.1v-9.17a1 1 0 01.293-.708l4.414-4.414A1 1 0 017.414 2h9.172l.099.005zM3.5 7.62v8.758L7.621 20.5h8.758l4.121-4.121V7.62L16.379 3.5H7.62L3.5 7.621z",
    fill: "currentColor"
  })));
}
SvgPlayResponsibly.displayName = 'PlayResponsibly';
export default SvgPlayResponsibly;